import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { tx } from "../lib/ddd/ddd";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import Response from "../components/objectPlaygroundComponents/Response";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { diff } from "jsondiffpatch";
import { Helmet } from "react-helmet";
import useWindowSize from "../hooks/useWindowSize";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import classes from "./ObjectPlayground.module.scss";
import { Row, Col, Container } from "react-bootstrap";
import Button from "../components/UI/Button";
import SaveInvoiceOptions from "../components/objectPlaygroundComponents/SaveInvoiceOptions";
import GetNewInvoiceOptions from "../components/objectPlaygroundComponents/GetNewInvoiceOptions";
import LoadingDots from "../components/UI/LoadingDots";
import { DDD, 
        mergeDDDIAndUI,
        getInvoiceValuesFromMergedDDDIAndUI } from "../lib/ddd/ddd";
import { json } from "react-router";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);


const FormTest = () => {
  const [chosenPartial, setChosenPartial] = useState("Normal");
  const [isLoading, setIsLoading] = useState(false);
  const [newInvoiceData, setNewInvoiceData] = useState(null);
  const [mergedJson, setMergedJson] = useState(null);
  const [editorJson, setEditorJson] = useState(null);
  const { width } = useWindowSize();
  const jsonEditorRef = useRef(null);

  const [saveInvRes, setSaveInvRes] = useState(null);
  const [saveInvReq, setSaveInvReq] = useState(null);
  const [isSavedLoading, setIsSavedLoading] = useState(null);

  const onSaveInvoice = (steps, docs) => {
    setIsSavedLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.DDDI_Save",
            args: {
              Complexity: chosenPartial,
              Object: { Invoice: editorJson },
              ReturnDoc: docs,
              Steps: steps,
            },
          },
          id: 3,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setSaveInvRes(res.data);
        let sentRequest =
          '{ method: "Extension.Execute", params: { extension: "EUeInvoices.DDD_SaveInvoice", args: { "Complexity": "' +
          { chosenPartial } +
          '", "Object": "' +
          JSON.stringify({ Invoice: editorJson }) +
          '", "ReturnDoc": "' +
          { docs } +
          '", "Steps": "' +
          { steps } +
          '"} }';

        setSaveInvReq(sentRequest);
        setIsSavedLoading(false);
      });
  };

  const onChangePartialHandler = (partial) => setChosenPartial(partial);

  useEffect(() => {
    if (jsonEditorRef.current) {
      const jsonEditorInstance = jsonEditorRef.current.jsonEditor;
      jsonEditorInstance.set(editorJson);
    }
  }, [editorJson]);

  const onGetNewInvoice = () =>{
    setIsLoading(true);
    ddd.APP_GetNewDDDIAndUIMerged({Complexity : chosenPartial, IncludeInfo : true}, {Complexity: chosenPartial,EditableOnly: true}).
      then(({DDDI_GetNew, UI_GetNew}) => {
        let deepClone = mergeDDDIAndUI(DDDI_GetNew.Invoice, UI_GetNew.Invoice);
        console.log(DDDI_GetNew.Invoice);
        setIsLoading(false);
        setNewInvoiceData(DDDI_GetNew.Invoice);
        setMergedJson(deepClone);
        let invoiceWithValues = getInvoiceValuesFromMergedDDDIAndUI(deepClone);
        setEditorJson(invoiceWithValues);
      });
  }
  const onGetNewInvoice2 = () => {
    setIsLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.DDDI_GetNew",
            args: {
              Complexity: chosenPartial,
              IncludeInfo: true,
            },
          },
          id: 2,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        const invoiceObject = res.data.result.Result.Invoice;
        console.log(invoiceObject);
        setNewInvoiceData(invoiceObject);

        axios
          .post(
            apiRequestAddress,
            {
              jsonrpc: "2.0",
              method: "Extension.Execute",
              params: {
                extension: "EUeInvoices.UI_Getnew",
                args: {
                  Complexity: chosenPartial,
                  EditableOnly: true,
                },
              },
              id: 52,
            },
            {
              withCredentials: true,
            }
          )
          .then((uiRes) => {
            const validObject = uiRes.data.result.Result.Invoice;
            
            if (uiRes.data.result.Status.toLowerCase() === "ok") {
              let newObj = JSON.parse(JSON.stringify(invoiceObject)); // obj1
              let combinedObj = {};
              for (const row in validObject) {
                if (newObj.Invoice[row] !== "undefined") {
                  if (row !== "_details") {
                    let valueRow1 = { defaultValue: newObj.Invoice[row] };
                    let valueRow2 = validObject[row];
                    combinedObj[row] = mergeKey(valueRow1, valueRow2);
                  } else {
                    combinedObj["_details"] = {};
                    for (let item in newObj.Invoice[row]) {
                      combinedObj["_details"] = {
                        ...combinedObj["_details"],
                        [item]: [],
                      };
                      for (let subObj of validObject[row][item]) {
                        combinedObj["_details"][item].push({ ...subObj });
                      }
                    }
                  }
                }
              }
              setIsLoading(false);
              setMergedJson(combinedObj);
              filterObject(combinedObj);
            }
          });
      });
  };

  const mergeKey = (value1, value2) => {
    return Object.assign({}, value1, value2);
  };

  const filterObject = (mergedObj) => {
    let filteredObj = {};

    for (const row in mergedObj) {
      if (row !== "_details") {
        let valueRow1 = { defaultValue: mergedObj[row].Value };
        filteredObj[row] = valueRow1.defaultValue;
      } else {
        filteredObj["_details"] = {};
        for (let item in mergedObj[row]) {
          filteredObj["_details"] = {
            ...filteredObj["_details"],
            [item]: [],
          };
          for (let [subObjIndex, subObj] of mergedObj[row][item].entries()) {
            filteredObj["_details"][item].push({});
            for (let subKey in subObj) {
              // console.log(mergedObj[row][item][subObjIndex][subKey]);
              let value = mergedObj[row][item][subObjIndex][subKey].Value;
              filteredObj["_details"][item][subObjIndex][subKey] = value;
            }
          }
        }
      }
    }

    // console.log(JSON.stringify(filteredObj));
    setEditorJson(filteredObj);
  };

  function updateValueByKey(obj, key, index, newValue) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (prop === key) {
          obj[prop].Value = newValue;
          setMergedJson(obj);
          filterObject(obj);
          return;
        }
      }
    }
    for (let prop in obj["_details"]) {
      for (let subObj = 0; subObj < obj["_details"][prop].length; subObj++) {
        if (index) {
          subObj = index;
        }
        for (let subKey in obj["_details"][prop][subObj]) {
          if (subKey === key) {
            obj["_details"][prop][subObj][subKey].Value = newValue;
            setMergedJson(obj);
            filterObject(obj);
            return;
          }
        }
      }
    }
  }

  const handleEditorChange = (e) => {
    const spottedDif = diff(editorJson, e);
    let changedKey = Object.keys(spottedDif)[0];
    let newValue = spottedDif[changedKey][1];

    try {
      if (mergedJson.changedKey !== "undefined" && changedKey !== "_details") {
        setMergedJson((prev) => ({
          ...prev,
          [changedKey]: {
            ...prev[changedKey],
            Value: newValue,
          },
        }));
      }
      if (changedKey === "_details") {
        let subItem = Object.keys(spottedDif["_details"])[0];
        let index = Object.keys(spottedDif["_details"][subItem])[0];
        let targetKey = Object.keys(spottedDif["_details"][subItem][index])[0];
        let newValue = spottedDif["_details"][subItem][index][targetKey][1];
        updateValueByKey(mergedJson, targetKey, index, newValue);
      }
    } catch (error) {
      console.log("An error occurred while updating the state:", error);
    }
  };

  const onAddNewItemHandler = (fieldName) => {
    let newValue = JSON.parse(
      JSON.stringify(mergedJson["_details"][fieldName][0])
    );

    for (let prop in mergedJson["_details"]) {
      if (fieldName === prop) {
        console.log("a match: " + fieldName);
        let updatedValues = { ...mergedJson };
        updatedValues["_details"][prop].push(newValue);
        setMergedJson(updatedValues);
        filterObject(updatedValues);
      }
    }
  };

  const onRemoveItemHandler = (fieldName, index) => {
    let newValue = JSON.parse(JSON.stringify(mergedJson));
    newValue["_details"][fieldName].splice(index, 1);
    setMergedJson(newValue);
    filterObject(newValue);
  };

  const findFieldProp = (jsonInfo, fieldName) => {
    if(!jsonInfo)
      return;

    if(jsonInfo[fieldName])
      return jsonInfo[fieldName];

    if(jsonInfo._details){
      for(let key in jsonInfo._details){
        for(let i =0;i<jsonInfo._details[key].length;i++){
          if(jsonInfo._details[key][i][fieldName])
            return jsonInfo._details[key][i][fieldName]
        }
      }
    }
  }
  const renderFormField = (fieldName, fieldConfig, isDetail, index) => {
    const { Type, Mandatory, Value, ValidValues, Trans } = fieldConfig;

    const handleFieldChange = (fieldName, value, index) => {
      console.log(fieldName);
      console.log(typeof value);
      console.log(mergedJson);
      let fieldProps = findFieldProp(mergedJson, fieldName);
      console.log(fieldProps);
      if(fieldProps){
        try{
        if(fieldProps.Type?.toLowerCase() === "number")
          value = parseFloat(value);
        if(fieldProps.Type?.toLowerCase() === "bool")
          value = value === "true" ? true : false;
        if(fieldProps.Type?.toLowerCase() === "date")
          value = isDate(value) ? value : null;
        
        }catch{
          value=null;
        }
      }
      updateValueByKey(mergedJson, fieldName, index, value);
    };
    const isDate = str => {
      let [y,M,d,h,m,s] = str.split(/[- : T Z]/);
      return (y && M <= 12 && d <= 31) ? true : false;
    }
    const tooltip = (
      <Tooltip>{Trans && Trans.Tooltip ? Trans.Tooltip : ""}</Tooltip>
    );

    return (
      <div key={Math.random().toString()} className="w-100">
        {!isDetail && (
          <>
            <div>
              {/* <label>{fieldName}</label> */}
              <label>{fieldName || Trans.Title}</label>
              {Trans && Trans.Tooltip && (
                <OverlayTrigger
                  placement="left"
                  overlay={tooltip}
                  key={`overlay-trigger-${fieldName}`}
                >
                  <svg
                    width="12"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: "0.2rem" }}
                  >
                    <path
                      d="M9.41656 1.4125C4.99542 1.4125 1.4125 4.9953 1.4125 9.41656C1.4125 13.8377 4.9953 17.4206 9.41656 17.4206C13.8377 17.4206 17.4206 13.8378 17.4206 9.41656C17.4206 4.99542 13.8378 1.4125 9.41656 1.4125ZM9.41656 0C14.6182 0 18.8331 4.21572 18.8331 9.41656C18.8331 14.6182 14.6174 18.8331 9.41656 18.8331C4.21491 18.8331 0 14.6174 0 9.41656C0 4.21491 4.21572 0 9.41656 0Z"
                      fill="#00436D"
                    />
                    <path
                      d="M9.88754 11.3001C9.88754 11.6901 9.5713 12.0063 9.18128 12.0063C8.79111 12.0063 8.47503 11.6901 8.47503 11.3001V10.9432C8.47503 9.9224 8.93946 9.39319 9.96462 8.79603C9.93876 8.811 10.2641 8.62309 10.3494 8.57217C11.2145 8.05604 11.5354 7.60783 11.5354 6.57117C11.5354 5.40461 10.7235 4.6542 9.18129 4.6542C7.77117 4.6542 6.82701 5.74575 6.82701 7.00832C6.82701 7.39834 6.51093 7.71458 6.12076 7.71458C5.73074 7.71458 5.41451 7.39834 5.41451 7.00832C5.41451 5.00749 6.94179 3.2417 9.18129 3.2417C11.4798 3.2417 12.9479 4.59855 12.9479 6.57117C12.9479 8.17082 12.3281 9.03628 11.0734 9.78511C10.9778 9.84218 10.6414 10.0364 10.6756 10.0165C10.0417 10.3857 9.88756 10.5615 9.88756 10.9432L9.88754 11.3001ZM9.13415 15.0667C8.61406 15.0667 8.19253 14.6452 8.19253 14.1251C8.19253 13.605 8.61406 13.1833 9.13415 13.1833C9.65423 13.1833 10.0758 13.605 10.0758 14.1251C10.0758 14.6452 9.65423 15.0667 9.13415 15.0667Z"
                      fill="#00436D"
                    />
                  </svg>
                </OverlayTrigger>
              )}
            </div>
            {ValidValues === undefined && fieldName !== "_details" && Type != "bool" && (
              <input
                type={Type}
                defaultValue={Value}
                name={fieldName}
                required={Mandatory}
                onBlur={(e) => {
                  handleFieldChange(fieldName, e.target.value, index);
                }}
                placeholder={
                  (Trans !== undefined ? Trans.Placeholder : "") || ""
                }
              />
            )}
            {ValidValues === undefined && fieldName !== "_details" && Type === "bool" && (
              <select
                name={fieldName}
                id={Math.random().toString()}
                onChange={(e) => {
                  handleFieldChange(fieldName, e.target.value, index);
                }}
                value={(mergedJson[fieldName].Value ?  "true" : "false")}
              >
                <option value={true} key="true">True</option>
                <option value={false} key="false">False</option>
              </select>
            )}
            {ValidValues && ValidValues.length > 0 && (
              <select
                name={fieldName}
                id={Math.random().toString()}
                onChange={(e) => {
                  handleFieldChange(fieldName, e.target.value, index);
                }}
                value={mergedJson[fieldName].Value || ""}
              >
                {ValidValues.map((value, index) => (
                  <option value={value.Code} key={index}>
                    {value.Code}
                  </option>
                ))}
              </select>
            )}
          </>
        )}
        {isDetail && (
          <div style={{ marginLeft: 50 / 16 + "rem" }} className="w-100">
            <div>
              <label>{fieldName}</label>
              {Trans && Trans.Tooltip && (
                <OverlayTrigger
                  placement="left"
                  overlay={tooltip}
                  key={`overlay-trigger-${fieldName}`}
                >
                  <svg
                    width="12"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: "0.2rem" }}
                  >
                    <path
                      d="M9.41656 1.4125C4.99542 1.4125 1.4125 4.9953 1.4125 9.41656C1.4125 13.8377 4.9953 17.4206 9.41656 17.4206C13.8377 17.4206 17.4206 13.8378 17.4206 9.41656C17.4206 4.99542 13.8378 1.4125 9.41656 1.4125ZM9.41656 0C14.6182 0 18.8331 4.21572 18.8331 9.41656C18.8331 14.6182 14.6174 18.8331 9.41656 18.8331C4.21491 18.8331 0 14.6174 0 9.41656C0 4.21491 4.21572 0 9.41656 0Z"
                      fill="#00436D"
                    />
                    <path
                      d="M9.88754 11.3001C9.88754 11.6901 9.5713 12.0063 9.18128 12.0063C8.79111 12.0063 8.47503 11.6901 8.47503 11.3001V10.9432C8.47503 9.9224 8.93946 9.39319 9.96462 8.79603C9.93876 8.811 10.2641 8.62309 10.3494 8.57217C11.2145 8.05604 11.5354 7.60783 11.5354 6.57117C11.5354 5.40461 10.7235 4.6542 9.18129 4.6542C7.77117 4.6542 6.82701 5.74575 6.82701 7.00832C6.82701 7.39834 6.51093 7.71458 6.12076 7.71458C5.73074 7.71458 5.41451 7.39834 5.41451 7.00832C5.41451 5.00749 6.94179 3.2417 9.18129 3.2417C11.4798 3.2417 12.9479 4.59855 12.9479 6.57117C12.9479 8.17082 12.3281 9.03628 11.0734 9.78511C10.9778 9.84218 10.6414 10.0364 10.6756 10.0165C10.0417 10.3857 9.88756 10.5615 9.88756 10.9432L9.88754 11.3001ZM9.13415 15.0667C8.61406 15.0667 8.19253 14.6452 8.19253 14.1251C8.19253 13.605 8.61406 13.1833 9.13415 13.1833C9.65423 13.1833 10.0758 13.605 10.0758 14.1251C10.0758 14.6452 9.65423 15.0667 9.13415 15.0667Z"
                      fill="#00436D"
                    />
                  </svg>
                </OverlayTrigger>
              )}
              <button
                className={classes.addBtn}
                onClick={() => onAddNewItemHandler(fieldName)}
                type="button"
              >
                Add
              </button>
            </div>
            {fieldConfig.map((item, itemIndex) => (
              <div
                style={{ paddingLeft: 55 / 16 + "rem" }}
                className={`${classes.subObject} w-100`}
                key={Math.random().toString()}
              >
                {mergedJson["_details"][fieldName].length > 1 && (
                  <button
                    className={classes.removeBtn}
                    type="button"
                    onClick={() => onRemoveItemHandler(fieldName, itemIndex)}
                  >
                    Remove
                  </button>
                )}
                {Object.entries(item).map(([labelName, fieldValue]) => {
                  if (fieldValue.Editable) {
                    if (fieldValue.ValidValues === undefined) {
                      return (
                        <div key={Math.random().toString()}>
                          <label>{labelName}</label>
                          <input
                            type={fieldValue.Type}
                            onBlur={(e) => {
                              handleFieldChange(
                                labelName,
                                e.target.value,
                                itemIndex
                              );
                            }}
                            defaultValue={fieldValue.Value}
                          />
                        </div>
                      );
                    } else {
                      // console.log(fieldValue.ValidValues);
                      return (
                        <div key={Math.random().toString()}>
                          <label>{labelName}</label>
                          <select
                            // name={fieldName}
                            id={Math.random().toString()}
                            onChange={(e) => {
                              handleFieldChange(
                                labelName,
                                e.target.value,
                                itemIndex
                              );
                            }}
                            value={fieldValue.Value || ""}
                          >
                            {fieldValue.ValidValues.map((value, index) => (
                              <option value={value.Code} key={index}>
                                {value.Code}
                              </option>
                            ))}
                          </select>
                        </div>
                      );
                    }
                  } else return <></>;
                })}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };
  /*useEffect(() => {
    onGetNewInvoice();
  }, [])*/
  return (
    <>
      <Helmet>
        <title>Object Playground | DDD Invoices</title>
      </Helmet>
      {width > 768 && (
        <div className={`w-100 p-5 ${classes.container}`}>
          <Row>
            <Col className="col-6 pe-3">
              <Container className="d-flex flex-column h-100">
                <Row>
                  <Col className="d-flex justify-content-between align-items-end">
                    <GetNewInvoiceOptions
                      onChangePartialHandler={onChangePartialHandler}
                      chosenPartial={chosenPartial}
                    />
                    <Button
                      className="px-lg-5 mt-3 w-100 py-1"
                      onClick={onGetNewInvoice}
                    >
                      {tx("DDDI_GetNew")}
                    </Button>
                  </Col>
                </Row>
                <Row style={{ flex: 1 }}>
                  <Col
                    className="d-flex"
                    style={{ maxHeight: "calc(66vh - 64px)" }}
                  >
                    {newInvoiceData && !isLoading && (
                      <div className={classes["new-invoice-response"]}>
                        <div className={classes["editor-wrapper"]}>
                          <Editor
                            mode={Editor.modes.code}
                            allowedModes={["code", "tree"]}
                            value={editorJson}
                            onChange={handleEditorChange}
                            ref={jsonEditorRef}
                          />
                        </div>
                      </div>
                    )}
                    {isLoading && !newInvoiceData && !mergedJson && (
                      <LoadingDots />
                    )}
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col className="col-6">
              {mergedJson && (
                <div className={classes["form-wrapper"]}>
                  <form>
                    {Object.entries(mergedJson).map(
                      ([fieldName, fieldConfig]) =>
                        renderFormField(fieldName, fieldConfig, false, null)
                    )}
                    {Object.entries(mergedJson["_details"]).map(
                      ([fieldName, fieldConfig]) =>
                        renderFormField(fieldName, fieldConfig, true, null)
                    )}
                  </form>
                </div>
              )}
            </Col>
          </Row>
          <Row className="mt-4">
            <Col className="col-6 pe-3" style={{ maxHeight: "66vh" }}>
              {editorJson && !isLoading && (
                <SaveInvoiceOptions onPassData={onSaveInvoice} />
              )}
            </Col>
            <Col className="col-6">
              {isSavedLoading && (
                <LoadingDots />
              )}
              {!isSavedLoading && saveInvRes && (
                <Response response={saveInvRes} request={saveInvReq} />
              )}
            </Col>
          </Row>
        </div>
      )}
      {width <= 768 && <MobileVersion />}
    </>
  );
};

export default FormTest;


